import { Component, input, inject, output, computed } from '@angular/core';

import { CommonModule } from '@angular/common';

import { TeamLogoLookupPipe } from '../shared/team-logo-lookup.pipe';
import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';

import { ISessionEntry } from './IRaceTiming';
import { PositionChangeIndicatorComponent } from './position-change-indicator.component';
import { RaceSessionService } from './race-session.service';
import { TimingTowerService, ToggleAction } from './timing-tower.service';

@Component({
	selector: 'vb-lxp-timing-tower',
	imports: [
		CommonModule,
		TeamLogoLookupPipe,
		TimespanMsPipe,
		TimespanShortPipe,
		PositionChangeIndicatorComponent,
	],
	templateUrl: './timing-tower.component.html',
	styleUrl: './timing-tower.component.css',
})
export class TimingTowerComponent {
	public enableMoreColumns = input(false);
	public activeClass = input('');
	public activeNumberClass = input('');
	public selectedClasses = input<string[]>([]);

	public selectionAdded = output<ISessionEntry>();
	public selectionRemoved = output<ISessionEntry>();

	public raceSessionService = inject(RaceSessionService);
	public timingTowerService = inject(TimingTowerService);
	public positionChangeStateByNumber = this.raceSessionService.positionChangeStateByNumber;

	public teams = computed(() => {
		const selectedClasses = this.selectedClasses();
		const entries = this.raceSessionService.raceTeamsPosition();

		return entries.filter((entry) => {
			return selectedClasses.length === 0 || selectedClasses.includes(entry.class);
		});
	});

	public toggleTeamSelection(team: ISessionEntry) {
		if (!team.playback?.url) {
			return;
		}
		const action = this.timingTowerService.toggleActive(team.number);
		switch (action) {
			case ToggleAction.ADDED: {
				this.selectionAdded.emit(team);
				break;
			}
			case ToggleAction.REMOVED: {
				this.selectionRemoved.emit(team);
				break;
			}
		}
	}

	public trackByFn(index: number, item: any): string {
		return item.number; // assuming unique team number
	}
}
